import graphql__443b8136d772c8c55afd from "./__generated__/MapEventMarkerTooltip_participativeModule.graphql.js";import { graphql, useFragment } from "react-relay";

import { useFormatEventDate } from "../../Events/formatEventDate";

const MapEventMarkerTooltip = props => {
  const participativeModule = useFragment(
    MapEventMarkerTooltip_participativeModule,
    props.participativeModule
  );
  const { title, thumbUrl, visualization: event } = participativeModule;
  const { startsAt } = event;

  const formatEventDate = useFormatEventDate();
  const startsAtString = formatEventDate(startsAt);

  return (
    <div>
      {thumbUrl && <img src={thumbUrl} width="100%" className="margin-bottom-xs" />}

      <div className="card-panel items-group-addon" style={{ width: "100%" }}>
        <div className="text-title-page">{title}</div>

        <div>{startsAtString}</div>
      </div>
    </div>
  );
};

const MapEventMarkerTooltip_participativeModule = graphql__443b8136d772c8c55afd;

export default MapEventMarkerTooltip;
